export const SUNGLASSES_FEATURES_MAP = {
    'Index1.5': [{title: 'UV 400 protective coating', isBold: false, icon: 'check'}],
    'Thin1.61': [
        {title: '20% Thinner lenses', isBold: true, icon: 'check'},
        {title: 'UV 400 protective coating', isBold: false, icon: 'check'},
    ],
    'Thin1.67': [
        {title: '40% Thinner lenses', isBold: true, icon: 'check'},
        {title: 'UV 400 protective coating', isBold: false, icon: 'check'},
    ],
};

export const DEFAULT_EYEGLASSES_PACKAGE_INDEX = 1;
export const DEFAULT_SUNGLASSES_PACKAGE_INDEX = 0;

export const LENS_PACKAGE_ICONS = {
    value: 'value',
    silver: 'value',
    trivex: 'value',
    standard: 'standard',
    'trivex plus': 'standard',
    gold: 'standard',
    polycarbonate: 'polycarbonate',
    'polycarbonate plus': 'polycarbonate',
    platinum: 'polycarbonate',
    super: 'polycarbonate',
    premium: 'premium',
    diamond: 'premium',
} as const;

export const SG_LENS_PACKAGE_ICONS = {
    'Index1.5': 'value',
    'Thin1.61': 'polycarbonate',
    'Thin1.67': 'super_thin',
    'Index1.53-HC': 'value',
    'Index1.59-HC': 'polycarbonate',
    'Index1.59-HMX': 'polycarbonate_plus',
} as const;

export const SG_LENS_PACKAGE_TITLE = {
    'Index1.5': 'Value',
    'Thin1.61': 'Standard',
    'Thin1.67': 'Super',
    'Index1.53-HC': 'Trivex',
    'Index1.59-HC': 'Polycarbonate',
    'Index1.59-HMX': 'Polycarbonate Plus',
};
